import { FormElement } from './form-element.model';

export class FormElementTextBox extends FormElement {
  public constructor() {
    super();

    this.intialize();
  }

  public intialize = (): void => {
    this.Value = '';
    this.Height = 0;
    this.Width = 0;
    this.MultiLine = false;
    this.Placeholder = '';
    this.ElementTypeId = 1;
  };

  public Value: string;
  public Height: number;
  public Width: number;
  public MultiLine: boolean;
  public Placeholder: string;
}
